import * as React from 'react';
import { LinkButton, Responsive, RoundButton } from '@cian/ui-kit';
import { ReviewsSubscribePopup, TSubscribeStatus } from '@cian/reviews-subscribe-component';

import { IconMail } from '../common/icons/mail';
import { trackSubscribeClick } from './tracking/tracking';

import * as styles from './index.css';

export interface IReviewsSubscribeProps {
  isOpenSubscribeReviewsPopup: boolean;
  email: string;
  emailError: string;
  subscribeStatus: TSubscribeStatus;
  isFetching: boolean;
  isUserAuthenticated: boolean;
}

export interface IReviewsSubscribeDispatchProps {
  subscribeChangeEmail(email: string | undefined): void;
  setEmailError(emailError: string): void;
  subscribeOpenPopup(): void;
  subscribeClosePopup(): void;
  onSubscribe(email: string): void;
  onUnsubscribe(email: string): void;
  setSubscribeStatus(setSubscribeStatus: TSubscribeStatus): void;
}

export type IProps = IReviewsSubscribeProps & IReviewsSubscribeDispatchProps;

const FAKE_EMAIL_MASK = /@social.cian.ru$/;
const EMAIL_MASK = /^.+@.+\.[a-zа-яё]+$/i;

export class ReviewsSubscribe extends React.Component<IProps, {}> {
  // eslint-disable-next-line react/no-deprecated
  public componentWillMount() {
    if (FAKE_EMAIL_MASK.test(this.props.email)) {
      this.props.subscribeChangeEmail('');
    }
  }

  public render() {
    const {
      subscribeStatus,
      isUserAuthenticated,
      subscribeOpenPopup,
      isFetching,
      email,
      emailError,
      isOpenSubscribeReviewsPopup,
      subscribeClosePopup,
      subscribeChangeEmail,
    } = this.props;

    const reviewsSubscribePopupTexts = {
      desktop: {
        subscribeDescription: 'Мы будем присылать на почту новые отзывы о специалисте',
      },
      mobile: {
        subscribeDescription: 'Мы будем присылать на почту новые отзывы о специалисте',
      },
    };

    return (
      <>
        <span className={styles['container']}>
          <Responsive desktop tablet>
            <LinkButton size="XS" theme="fill_secondary" onClick={this.onSubscribeOpen}>
              {
                // Отписатсья показываем только авторизованным пользователям
                ['subscribe', 'unsubscribeError'].includes(subscribeStatus) && isUserAuthenticated
                  ? 'Отписаться'
                  : 'Подписаться'
              }
            </LinkButton>
          </Responsive>
          <Responsive phone>
            <RoundButton theme="fill_light" onClick={subscribeOpenPopup} icon={<IconMail />} title="subscribe" />
          </Responsive>
        </span>
        <ReviewsSubscribePopup
          email={email}
          inputError={emailError}
          isOpen={isOpenSubscribeReviewsPopup}
          loading={isFetching}
          onClose={subscribeClosePopup}
          onEmailChange={subscribeChangeEmail}
          onSubscribe={this.onSubscribe}
          onUnsubscribe={this.onUnsubscribe}
          status={subscribeStatus}
          texts={reviewsSubscribePopupTexts}
        />
      </>
    );
  }

  private onSubscribeOpen = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const { subscribeStatus, isUserAuthenticated } = this.props;

    e.preventDefault();
    this.props.subscribeOpenPopup();

    const isUnsubscribe = ['subscribe', 'unsubscribeError'].includes(subscribeStatus) && isUserAuthenticated;
    trackSubscribeClick(!isUnsubscribe);
  };

  private onSubscribe = () => {
    const { email } = this.props;

    if (!email.trim().length) {
      this.props.setEmailError('Введите email');

      return;
    }

    if (!EMAIL_MASK.test(email)) {
      this.props.setEmailError('Неверный e-mail адрес');

      return;
    }

    this.props.onSubscribe(email);
  };

  private onUnsubscribe = () => {
    this.props.onUnsubscribe(this.props.email);
  };
}
